<ng-template #itemTemplate let-item>
    <span [pTooltip]="getTooltip(item.key)">{{ item.val }}</span>
</ng-template>

<ng-template #selectedItemTemplate let-item>
    <span [pTooltip]="getTooltip(item.key)">{{ item.val }}</span>
</ng-template>

<phx-select
    #dropdownElement
    [multiple]="multiple()"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [items]="filteredItems()"
    [showClear]="showClear()"
    [optionValue]="'key'"
    [optionLabel]="'val'"
    [loading]="loadingSig()"
    (onShow)="onShow()"
    [itemTemplate]="itemTemplate"
    [selectedItemTemplate]="selectItemTemplate"
    [searchable]="searchable()"
    [placeholder]="placeholder()"
    [dataTestId]="dataTestId()"
    (onFilter)="onFilter($event)"
    [styleClass]="styleClass()"
    [(value)]="value"
    (onModelChange)="onModelChangeInternal($event)"
    [size]="size()"
    [disabled]="disabled()"
    [overlayOptions]="overlayOptions()"
/>
